export const convertToTransitKind = (subType) => {
  switch (subType) {
    case 'train':
    case 'subway':
    case 'cartrain':
    case 'nighttrain':
    case 'tram':
    case 'cablecar':
      return 'train'

    case 'bus':
    case 'busferry':
    case 'nightbus':
      return 'bus'

    case 'plane':
    case 'flight':
    case 'helicopter':
      return 'plane'

    case 'ferry':
    case 'carferry':
      return 'ferry'

    case 'car':
    case 'rideshare':
      return 'car'

    case 'shuttle':
    case 'towncar':
    case 'airport-transfer':
      return 'airport-transfer'

    case 'taxi':
      return 'taxi'

    case 'walk':
      return 'walk'

    case 'animal':
      return 'animal'

    case 'cycle':
      return 'cycle'

    default:
      return null
  }
}
